import { RenderableErrorResponse } from '../../../../../services/exports/Types';
import { useSelector } from 'react-redux';
import { companiesApiSlice } from '../../../../../store/api-slices';
import { selectCompanyId } from '../../../../../store/slices/InitialDataSlice';
import { store } from '../../../../../store';

interface ErrorPayload {
  product_ids: number[];
  modifier_ids: number[];
}

const useOutOfStockErrorHandler = () => {
  const companyId = useSelector(selectCompanyId);

  const handler = (response: RenderableErrorResponse<ErrorPayload>): void => {
    const productIds = response.response.data.payload.product_ids;
    const modifierIds = response.response.data.payload.modifier_ids;

    store.dispatch(
      companiesApiSlice.util.updateQueryData('getCompanyMenusData', companyId, (draft) => {
        productIds.forEach((productId) => {
          draft.products[productId].is_available = false;
        });
        modifierIds.forEach((productId) => {
          draft.modifiers[productId].is_available = false;
        });
      }),
    );
  };

  return handler;
};

export default useOutOfStockErrorHandler;
